// Sticky add-to-bag bar (sections/sticky-atc.liquid; phones and tablets). Mirrors the product section's choice from
// "variant:changed" (assets/product.js; the latest one is also in DE.productState): price, "Colour · Size" (or the
// colour, "Choose a size", "Sold out") and one button: "Add to bag", always active while the choice is in stock, adds
// the chosen variant (DE.cart.add), or, before a size is chosen, sends nothing and asks the product section for its
// size prompt ("product:choose-size": "Please select a size", the sizes scrolled into view, outlined and focused);
// "Sold out" is disabled. After adding, the toast above the bar shows "Added. <free-shipping message>", the bar and "View bag" for
// 6 s (role="status"). Adds .has-sticky-atc to <html> for browsers without :has() (the product section's CSS).
const DE = (window.DE = window.DE || {});
const TOAST_SECONDS = 6;

const parse = (el) => {
  try {
    return JSON.parse(el?.textContent || 'null');
  } catch {
    return null;
  }
};

class StickyAtc {
  constructor(el) {
    this.el = el;
    this.texts = parse(el.querySelector('[data-satc-strings]')) || {};
    this.button = el.querySelector('[data-satc-button]');
    this.toastEl = el.querySelector('[data-satc-toast]');
    this.state = null;
    document.documentElement.classList.add('has-sticky-atc');

    this.button?.addEventListener('click', () => this.act());
    this.off = DE.on('variant:changed', (event) => this.render(event.detail));
    if (DE.productState) this.render(DE.productState);
  }

  render(state) {
    if (!state || (this.el.dataset.handle && state.handle && state.handle !== this.el.dataset.handle)) return;
    this.state = state;
    const { texts } = this;
    const price = this.el.querySelector('[data-satc-price]');
    if (price && state.price !== undefined) price.textContent = DE.formatMoney(state.price);

    let detail;
    if (state.soldOut) detail = texts.sold_out || 'Sold out';
    else if (state.size !== null && state.size !== undefined) {
      detail = state.colour
        ? (texts.colour_size || '[colour] · [size]').replace('[colour]', state.colour).replace('[size]', state.size)
        : state.size;
    } else detail = state.colour || texts.choose || 'Choose a size';
    const detailEl = this.el.querySelector('[data-satc-detail]');
    if (detailEl) detailEl.textContent = detail;

    const button = this.button;
    if (!button) return;
    const unavailable = state.soldOut || state.unavailable;
    button.disabled = !!unavailable;
    button.classList.toggle('satc__btn--sold', !!state.soldOut);
    button.textContent = unavailable ? texts.sold_out || 'Sold out' : texts.add || 'Add to bag';
  }

  act() {
    const state = this.state;
    if (!state || state.soldOut || state.unavailable) return;
    if (state.ready && state.variantId) this.add(state.variantId);
    else DE.emit('product:choose-size');
  }

  async add(id) {
    const button = this.button;
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    try {
      const detail = await DE.cart.add([{ id, quantity: 1 }], { source: 'sticky-atc' });
      this.toast(detail.cart);
    } catch (error) {
      this.toast(null, error.message);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  toast(cart, message = '') {
    const holder = this.toastEl;
    if (!holder) return;
    clearTimeout(this.timer);
    if (message) {
      holder.innerHTML = `<div class="satc__toast-box"><p class="free-shipping__text">${DE.escape(message)}</p></div>`;
    } else {
      const prefix = this.texts.added || 'Added.';
      const bar = cart ? DE.freeShippingHTML(cart.total_price, 'satc__shipping') : '';
      const cartUrl = DE.config?.routes?.cart || '/cart';
      const viewBag = this.texts.view_bag
        ? `<a class="satc__view" href="${DE.escape(cartUrl)}" data-open-cart>${DE.escape(this.texts.view_bag)}</a>`
        : '';
      holder.innerHTML = `<div class="satc__toast-box">${bar || '<p class="free-shipping__text"></p>'}${viewBag}</div>`;
      const text = holder.querySelector('.free-shipping__text');
      if (text) text.textContent = `${prefix} ${text.textContent}`.trim();
    }
    this.timer = setTimeout(() => (holder.innerHTML = ''), TOAST_SECONDS * 1000);
  }

  destroy() {
    clearTimeout(this.timer);
    this.off?.();
  }
}

const instances = new WeakMap();
const init = (scope = document) => {
  scope.querySelectorAll('[data-sticky-atc]').forEach((el) => {
    if (!instances.has(el)) instances.set(el, new StickyAtc(el));
  });
};

document.addEventListener('shopify:section:load', (event) => init(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-sticky-atc]').forEach((el) => {
    instances.get(el)?.destroy();
    instances.delete(el);
  });
  if (!document.querySelector('[data-sticky-atc]')) document.documentElement.classList.remove('has-sticky-atc');
});

init();
